import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import TimeEntryList from "./TimeEntryList";
import WeeklyOverview from "./WeeklyOverview";

const Tracking = () => {
    return (
        <Routes>
            <Route path="overview" element={<WeeklyOverview />} />
            <Route path="tracking" element={<TimeEntryList />} />
            <Route path="*" element={<Navigate to="overview" />} />
        </Routes>
    );
};

export default Tracking;
